/* @flow */

// const origin = typeof global.location !== 'undefined' ? global.location.origin : '';
// const protocol = typeof global.location !== 'undefined' ? global.location.protocol : 'http:';

// export const API = protocol + (/dev/.test(origin)
//     ? '//devapi.plom.com.br'
//     : '//api.plom.com.br');
export const API = 'https://api.plom.com.br';

export const API_PAGUEMAX = 'http://paguemax.com.br';
export const MOEDA = 'R$';
export const CHAVE_TOKEN = 'token-api';
export const DIAS_PERSISTENCIA_TOKEN_ALFRED = 1;
export const DIRETORIO_IMAGENS_TEMA = '/theme/dist/html/default/assets/app/media/img';
export const DIRETORIO_IMAGENS_UPLOAD = `${API}/imagens/`;
export const DIRETORIO_IMAGENS_UPLOAD_ORIGINAL = `${DIRETORIO_IMAGENS_UPLOAD}original/`;
export const MOMENT_FORMATO_BANCO = 'Y-MM-DD HH:mm:ss';
export const PAGINA_INICIAL = 0;
export const INTERVALO_POLL_NOTIFICACOES = 15000;

export const BRAND_COLOR = '#af5bf1';
export const SUCCESS_COLOR = '#34bfa3';
export const INFO_COLOR = '#36a3f7';
export const DANGER_COLOR = '#f4516c';
export const PLOM_COLOR = '#633993';

export const ARRAY_STATE_COLORS = [
    'success',
    'warning',
    'danger',
    'info',
    'primary',
    'secondary',
    'warning',
    'brand',
    'accent',
    'focus',
    'metal',
    'light',
];
